export const environment = {
  production: false,
  version: '2025-06-03'
};
